import { render, staticRenderFns } from "./WDGTabs.vue?vue&type=template&id=5d6a3958&"
import script from "./WDGTabs.vue?vue&type=script&lang=js&"
export * from "./WDGTabs.vue?vue&type=script&lang=js&"
import style0 from "./WDGTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports